export enum LoginAction {
  login = 'login',
  forgot = 'forgot',
  reset = 'reset',
  twoFA = '2FA',
  activation = 'activation'
}
